import React, {useRef, useState} from "react";
import {World} from "../../assets/icons";
import {useLanguage} from "../../hooks/LanguageContext";

const SelectLanguage = () => {
	const { language, changeLanguage } = useLanguage(); // Access context
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	const handleLanguageChange = (lang) => {
		changeLanguage(lang); // Update the language
		setIsOpen(false);
	};

	const handleClickOutside = (event) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
			setIsOpen(false);
		}
	};

	React.useEffect(() => {
		if (isOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, [isOpen]);

	return (
		<div className="relative w-[90px] h-[28px] cursor-pointer" ref={dropdownRef}>
			<div onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-[10px]">
				<World className="w-4 h-4" />
				<span className="text-[20px] leading-[28px] font-medium text-gray-500">
					{language === "en" ? "English" : "العربية"}
				</span>
			</div>
			{isOpen && (
				<div className="absolute top-full mt-2 w-full bg-white border border-gray-300 rounded shadow-lg">
					<div
						onClick={() => handleLanguageChange("en")}
						className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
					>
						English
					</div>
					<div
						onClick={() => handleLanguageChange("ar")}
						className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
					>
						العربية
					</div>
				</div>
			)}
		</div>
	);
};

export default SelectLanguage;
